const SUPPORTED_LOCALES = ["us", "uk", "en", "jp", "ch", "kr", "fr"];
const LOCALE_ALIASES = {
  en: "us",
  uk: "us",
};

function normalizeLocale(localeCode) {
  return LOCALE_ALIASES[localeCode] || localeCode;
}

function detectLocale() {
  if (window.__LOCALE__) {
    const l = window.__LOCALE__.toLowerCase();
    if (SUPPORTED_LOCALES.includes(l)) return normalizeLocale(l);
  }
  // Check URL path segment, e.g. /jp or /jp/...
  const pathLocale = location.pathname.split("/").find((s) => SUPPORTED_LOCALES.includes(s.toLowerCase()));
  if (pathLocale) return normalizeLocale(pathLocale.toLowerCase());
  // Fall back to browser language
  const lang = (navigator.language || "en").toLowerCase();
  if (lang.startsWith("ja")) return "jp";
  if (lang.startsWith("zh")) return "ch";
  if (lang.startsWith("ko")) return "kr";
  if (lang.startsWith("fr")) return "fr";
  return "us";
}

// Button image paths per locale.
// Locale codes: us/uk/en (English), jp (JP), ch (CH), kr (KR), fr (FR)
// Button texts per locale:
//   us / ch / kr  — TRY-ON IN AR       |  VIEW IN 3D
//   jp            — ARで試着する        |  3Dで表示
//   fr            — ESSAYER EN RA       |  VISUALISER EN 3D
//
// Variants:
//   tryArDark      — try-ar, dark text  (silver / blue watch)
//   tryArLight     — try-ar, light text (black watch)
//   learnMoreDark  — learn-more, dark   (silver / blue, 3D mode)
//   learnMoreLight — learn-more, light  (black, 3D mode)
//   learnMoreAr    — learn-more shown in AR mode
//   viewIn3d       — replaces try-ar btn in AR mode ("back to 3D")
const LOCALE_ASSETS = {
  us: {
    tryArDark:      "/assets/images/buttons/us/try-ar-dark.webp",
    tryArLight:     "/assets/images/buttons/us/try-ar-light.webp",
    learnMoreDark:  "/assets/images/buttons/us/learn-more-dark.webp",
    learnMoreLight: "/assets/images/buttons/us/learn-more-light.webp",
    learnMoreAr:    "/assets/images/buttons/us/learn-more-ar.webp",
    viewIn3d:       "/assets/images/buttons/us/view-3d.webp",
  },
  jp: {
    tryArDark:      "/assets/images/buttons/jp/try-ar-dark.webp",
    tryArLight:     "/assets/images/buttons/jp/try-ar-light.webp",
    learnMoreDark:  "/assets/images/buttons/jp/learn-more-dark.webp",
    learnMoreLight: "/assets/images/buttons/jp/learn-more-light.webp",
    learnMoreAr:    "/assets/images/buttons/jp/learn-more-ar.webp",
    viewIn3d:       "/assets/images/buttons/jp/view-3d.webp",
  },
  ch: {
    tryArDark:      "/assets/images/buttons/ch/try-ar-dark.webp",
    tryArLight:     "/assets/images/buttons/ch/try-ar-light.webp",
    learnMoreDark:  "/assets/images/buttons/ch/learn-more-dark.webp",
    learnMoreLight: "/assets/images/buttons/ch/learn-more-light.webp",
    learnMoreAr:    "/assets/images/buttons/ch/learn-more-ar.webp",
    viewIn3d:       "/assets/images/buttons/ch/view-3d.webp",
  },
  kr: {
    tryArDark:      "/assets/images/buttons/kr/try-ar-dark.webp",
    tryArLight:     "/assets/images/buttons/kr/try-ar-light.webp",
    learnMoreDark:  "/assets/images/buttons/kr/learn-more-dark.webp",
    learnMoreLight: "/assets/images/buttons/kr/learn-more-light.webp",
    learnMoreAr:    "/assets/images/buttons/kr/learn-more-ar.webp",
    viewIn3d:       "/assets/images/buttons/kr/view-3d.webp",
  },
  fr: {
    tryArDark:      "/assets/images/buttons/fr/try-ar-dark.webp",
    tryArLight:     "/assets/images/buttons/fr/try-ar-light.webp",
    learnMoreDark:  "/assets/images/buttons/fr/learn-more-dark.webp",
    learnMoreLight: "/assets/images/buttons/fr/learn-more-light.webp",
    learnMoreAr:    "/assets/images/buttons/fr/learn-more-ar.webp",
    viewIn3d:       "/assets/images/buttons/fr/view-3d.webp",
  },
};

export const locale = detectLocale();
export const localeAssets = LOCALE_ASSETS[locale];
